"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
/* eslint-disable */
const react_1 = require("react");
const prop_types_1 = __importDefault(require("prop-types"));
const html_react_parser_1 = __importDefault(require("html-react-parser"));
const uniq_1 = __importDefault(require("lodash/uniq"));
const pattern_library_hooks_use_breakpoints_1 = require("@saatva-bits/pattern-library.hooks.use-breakpoints");
const pattern_library_components_tooltip_1 = require("@saatva-bits/pattern-library.components.tooltip");
const ProductFeatures_module_scss_1 = __importDefault(require("./ProductFeatures.module.scss"));
/**
 * Parses Prismic templates into valid jsx
 * Checks if there are tooltips defined in the template and renders the
 * corresponding FeatureTooltip by its own
 */
const ProductFeatures = ({ features }) => {
    const { isMobile } = (0, pattern_library_hooks_use_breakpoints_1.useBreakpoints)('mobile');
    // prismic sintax defined for tooltip info is "[info: some tooltip text.]"
    const tooltipOpenTag = '[info: ';
    const tooltipCloseTag = ']';
    // get indexes if the node of features contains the open tag ([info: ]) for tooltip info
    const indexes = indexOfAll(tooltipOpenTag, features);
    // array with tooltip texts (avoid duplications)
    const tooltipsInfo = indexes.length && (0, uniq_1.default)(indexes.map(index => {
        // start position of the tooltip text (is the index of the found tooltip info open tag plus his length)
        const startIndex = index + tooltipOpenTag.length;
        // end position of the tooltip text (starts finding the position after the startIndex position)
        const endIndex = features.indexOf(tooltipCloseTag, startIndex);
        // extracts the tooltip text based on start and end positions in the node
        const tooltipText = features.substring(startIndex, endIndex);
        return tooltipText;
    }));
    if (tooltipsInfo) {
        const featuresContent = [];
        tooltipsInfo.forEach((tooltipText, i) => {
            const tooltipTag = `${tooltipOpenTag}${tooltipText}${tooltipCloseTag}`; // entire tooltip tag ([info: tooltip text.])
            const parsedContent = (0, html_react_parser_1.default)(features, {
                replace: node => {
                    /*
                        if the node is a text and the text in the node includes the entire tooltip tag
                        it's going to replace the tooltip tag with the tooltip component
                    */
                    if (node.type === 'text' && node.data.includes(tooltipTag)) {
                        node.data = node.data.replace(tooltipTag, ''); // removing the tooltip tag from the text
                        // return the text and the actual tooltip
                        return ((0, jsx_runtime_1.jsx)(FeatureTooltip, { text: node.data, tooltipText: tooltipText, isMobile: isMobile }, `feature-tooltip-${i}`));
                    }
                }
            });
            featuresContent.push(parsedContent);
        });
        return featuresContent;
    }
    return (0, html_react_parser_1.default)(features);
};
ProductFeatures.propTypes = {
    features: prop_types_1.default.node.isRequired
};
// return array of index positions where the value match the string content
function indexOfAll(value, content) {
    const indexes = [];
    let index = content.indexOf(value);
    while (index !== -1) {
        indexes.push(index);
        index = content.indexOf(value, index + 1);
    }
    return indexes;
}
function FeatureTooltip({ text, tooltipText, isMobile }) {
    const [tooltipOpen, setTooltipOpen] = (0, react_1.useState)(false);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [text, (0, jsx_runtime_1.jsx)(pattern_library_components_tooltip_1.Tooltip, { bumperBottom: "0", bumperLeft: "2px", bumperRight: "0", bumperTop: "-7px", dialogWidth: "200px", className: ProductFeatures_module_scss_1.default.featureTooltip, dialogClassName: ProductFeatures_module_scss_1.default.featureTooltipDialog, isToolTipActive: tooltipOpen, toggleToolTip: (_, activeState) => setTooltipOpen(activeState), toolTipTextBlocks: [tooltipText], isMobile: isMobile })] }));
}
FeatureTooltip.propTypes = {
    text: prop_types_1.default.string.isRequired,
    tooltipText: prop_types_1.default.string.isRequired,
    isMobile: prop_types_1.default.bool
};
exports.default = ProductFeatures;
//# sourceMappingURL=ProductFeatures.js.map